import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
  background: linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%);
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Breadcrumbs = styled.nav`
  margin-bottom: 30px;
  font-size: 14px;
  color: #666;

  a {
    color: #7c3aed;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    margin: 0 8px;
    color: #999;
  }
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
`;

const AppBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #7c3aed;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1a1a1a;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const LastUpdated = styled.p`
  color: #666;
  font-size: 14px;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    padding: 25px;
  }
`;

const TableOfContents = styled.div`
  background: #faf5ff;
  border-left: 4px solid #7c3aed;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 30px;

  h3 {
    color: #1a1a1a;
    margin-bottom: 15px;
    font-size: 1.1rem;
  }

  ol {
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: #7c3aed;
    text-decoration: none;
    font-size: 15px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Section = styled.section`
  margin-bottom: 35px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  color: #1a1a1a;
  font-size: 1.4rem;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9d5ff;
  display: flex;
  align-items: center;
  gap: 10px;

  .icon {
    color: #7c3aed;
  }
`;

const Paragraph = styled.p`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  font-size: 15px;
`;

const ContactCard = styled.div`
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  color: white;
  padding: 25px;
  border-radius: 12px;
  text-align: center;

  h3 {
    margin-bottom: 15px;
    font-size: 1.2rem;
  }

  p {
    margin-bottom: 10px;
    font-size: 15px;
  }

  a {
    color: white;
    font-weight: 600;
  }
`;

const RelatedLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;

  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #f5f3ff;
    color: #7c3aed;
    padding: 12px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      background: #7c3aed;
      color: white;
    }
  }
`;

export const InstrumentSnapPrivacyPage = () => {
  return (
    <>
      <Navbar />
      <PageContainer>
        <ContentWrapper>
          <Breadcrumbs>
            <Link to="/">Inicio</Link>
            <span>›</span>
            <span>Politica de Privacidad - InstrumentSnap</span>
          </Breadcrumbs>

          <Header>
            <AppBadge>
              InstrumentSnap
            </AppBadge>
            <Title>Politica de Privacidad</Title>
            <LastUpdated>Ultima actualizacion: 22 de febrero de 2026</LastUpdated>
          </Header>

          <Card>
            <TableOfContents>
              <h3>Tabla de Contenidos</h3>
              <ol>
                <li><a href="#introduccion">Introduccion</a></li>
                <li><a href="#datos-recopilados">Datos que Recopilamos</a></li>
                <li><a href="#uso-datos">Como Usamos sus Datos</a></li>
                <li><a href="#terceros">Terceros y Comparticion de Datos</a></li>
                <li><a href="#almacenamiento">Almacenamiento y Seguridad</a></li>
                <li><a href="#derechos">Sus Derechos</a></li>
                <li><a href="#menores">Privacidad de Menores</a></li>
                <li><a href="#cookies">Cookies y Tecnologias Similares</a></li>
                <li><a href="#internacional">Transferencias Internacionales</a></li>
                <li><a href="#cambios">Cambios a esta Politica</a></li>
                <li><a href="#contacto">Contacto</a></li>
              </ol>
            </TableOfContents>

            <Section id="introduccion">
              <SectionTitle>
                <span className="icon">1.</span> Introduccion
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion describira el proposito de esta politica de privacidad
                para InstrumentSnap, una aplicacion desarrollada por <strong>Monaco IT Services</strong>.
              </Paragraph>
            </Section>

            <Section id="datos-recopilados">
              <SectionTitle>
                <span className="icon">2.</span> Datos que Recopilamos
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion detallara los tipos de datos personales que recopilamos
                al usar InstrumentSnap.
              </Paragraph>
            </Section>

            <Section id="uso-datos">
              <SectionTitle>
                <span className="icon">3.</span> Como Usamos sus Datos
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion explicara como utilizamos la informacion recopilada
                para proporcionar y mejorar nuestros servicios.
              </Paragraph>
            </Section>

            <Section id="terceros">
              <SectionTitle>
                <span className="icon">4.</span> Terceros y Comparticion de Datos
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion indicara con que terceros compartimos datos y bajo
                que condiciones.
              </Paragraph>
            </Section>

            <Section id="almacenamiento">
              <SectionTitle>
                <span className="icon">5.</span> Almacenamiento y Seguridad
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion describira las medidas de seguridad que implementamos
                para proteger su informacion.
              </Paragraph>
            </Section>

            <Section id="derechos">
              <SectionTitle>
                <span className="icon">6.</span> Sus Derechos
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion detallara los derechos que tiene sobre sus datos
                personales.
              </Paragraph>
            </Section>

            <Section id="menores">
              <SectionTitle>
                <span className="icon">7.</span> Privacidad de Menores
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion explicara nuestra politica respecto a menores de edad.
              </Paragraph>
            </Section>

            <Section id="cookies">
              <SectionTitle>
                <span className="icon">8.</span> Cookies y Tecnologias Similares
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion describira el uso de cookies y tecnologias similares
                en InstrumentSnap.
              </Paragraph>
            </Section>

            <Section id="internacional">
              <SectionTitle>
                <span className="icon">9.</span> Transferencias Internacionales
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion explicara como manejamos las transferencias
                internacionales de datos.
              </Paragraph>
            </Section>

            <Section id="cambios">
              <SectionTitle>
                <span className="icon">10.</span> Cambios a esta Politica
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion indicara como notificaremos cambios a esta politica
                de privacidad.
              </Paragraph>
            </Section>

            <Section id="contacto">
              <SectionTitle>
                <span className="icon">11.</span> Contacto
              </SectionTitle>
              <Paragraph>
                Si tiene preguntas sobre esta Politica de Privacidad o sobre como manejamos sus datos,
                puede contactarnos:
              </Paragraph>
              <ContactCard>
                <h3>Monaco IT Services</h3>
                <p>Email: <a href="mailto:support@monaco-it-services.cl">support@monaco-it-services.cl</a></p>
                <p>Sitio web: <a href="https://monaco-it-services.cl" target="_blank" rel="noopener noreferrer">monaco-it-services.cl</a></p>
                <p>Pais: Chile</p>
              </ContactCard>
            </Section>

            <RelatedLinks>
              <Link to="/instrumentsnap/terms">
                Terminos de Servicio
              </Link>
              <Link to="/">
                Volver al Inicio
              </Link>
            </RelatedLinks>
          </Card>
        </ContentWrapper>
      </PageContainer>
      <Footer />
    </>
  );
};
